var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 21,
    viewBox: "0 0 35 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 48097461"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 543486",
    x: 27.4883,
    y: 15.5469,
    width: 5.01178,
    height: 5.01178,
    rx: 1.45802,
    fill: "#1a1a1c"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Vector 26"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.3404 0.445312H11.0333C10.519 0.445312 10.051 0.742532 9.83236 1.20804L1.63032 18.6705C1.21703 19.5504 1.85911 20.5613 2.83125 20.5613H8.22654C8.74283 20.5613 9.21224 20.2618 9.42979 19.7936L17.5437 2.3312C17.9523 1.45174 17.3102 0.445312 16.3404 0.445312Z",
    fill: "#1a1a1c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.3959 0.445312H32.651C33.6196 0.445312 34.2618 1.44965 33.8553 2.32889L30.4087 9.78408C30.1916 10.2535 29.7216 10.5541 29.2044 10.5541H21.8742L25.7567 18.6615C26.1785 19.5422 25.5365 20.5613 24.5601 20.5613H19.2629C18.7484 20.5613 18.2804 20.264 18.0618 19.7983L14.6103 12.4446C14.1973 11.5648 14.8394 10.5541 15.8113 10.5541H21.8742L26.1916 1.21534C26.4087 0.745867 26.8787 0.445312 27.3959 0.445312Z",
    fill: "#1a1a1c"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.510626fe8fdce0e4d6cea16ab3aff443.svg";
export { ForwardRef as ReactComponent };